import React from 'react';
import RightArrow from './img/right.svg'
import './option-item.less'

const OptionItem = (props = { showDescLabel: false }) => {
    return (
        <div
            className={
                [
                    'merchant-option-item',
                    props.disable ? 'disable' : null,
                    props.active ? 'active' : null
                ].join(' ')
            }
            onClick={()=>{
                if (props.disable) return;
                if (props.onClick) props.onClick(props.data);
            }}
        >
            <div className="left">
                <div className="title" title={props.title}>
                    <h2>{props.title}</h2>
                    {props.disable && props.showDisableTag && <span className="tag">已冻结</span>}
                </div>
                <span className="desc" title={props.desc}>
                    {
                        props.showDescLabel && '所属商户: '
                    }
                    { props.desc }
                </span>
            </div>
            <div className="right">
                {
                    !props.disable && <img
                        src={RightArrow}
                        className="arrow"
                        alt="arrow"
                    />
                }
            </div>
        </div>
    );
};


export default OptionItem;